import * as React from 'react';
import { Viewer } from '@react-pdf-viewer/core';
import authService from "../services/authService";


import './CorePdfViewer.css';



export const CorePdfViwer = ({ url }: { url: string }) => {

    return (
        <Viewer fileUrl={url} withCredentials={true} httpHeaders={
                {
                    Authorization: `Bearer ${authService.getJwt()}`
                }
        } />
    );

}